import React from "react";

const AsideBar = () => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M2.8125 14.6719H16.1797C17.875 14.6719 18.7578 13.7969 18.7578 12.125V2.61719C18.7578 0.945312 17.875 0.0703125 16.1797 0.0703125H2.8125C1.125 0.0703125 0.242188 0.9375 0.242188 2.61719V12.125C0.242188 13.7969 1.125 14.6719 2.8125 14.6719ZM2.91406 13.1172C2.19531 13.1172 1.79688 12.7422 1.79688 11.9844V2.75781C1.79688 2 2.19531 1.625 2.91406 1.625H6.47656V13.1172H2.91406ZM16.0781 1.625C16.7969 1.625 17.1953 2 17.1953 2.75781V11.9844C17.1953 12.7422 16.7969 13.1172 16.0781 13.1172H7.95312V1.625H16.0781ZM4.94531 4.48438C5.22656 4.48438 5.46094 4.24219 5.46094 3.97656C5.46094 3.71094 5.22656 3.47656 4.94531 3.47656H3.34375C3.0625 3.47656 2.82812 3.71094 2.82812 3.97656C2.82812 4.24219 3.0625 4.48438 3.34375 4.48438H4.94531ZM4.94531 6.58594C5.22656 6.58594 5.46094 6.35156 5.46094 6.07812C5.46094 5.8125 5.22656 5.57812 4.94531 5.57812H3.34375C3.0625 5.57812 2.82812 5.8125 2.82812 6.07812C2.82812 6.35156 3.0625 6.58594 3.34375 6.58594H4.94531ZM4.94531 8.67969C5.22656 8.67969 5.46094 8.45312 5.46094 8.17969C5.46094 7.91406 5.22656 7.6875 4.94531 7.6875H3.34375C3.0625 7.6875 2.82812 7.91406 2.82812 8.17969C2.82812 8.45312 3.0625 8.67969 3.34375 8.67969H4.94531Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default AsideBar;
